/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import {accounting} from 'accounting'
import jMoment from 'moment-jalaali'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import $ from 'jquery'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import StatisticalComponent from '../BaseComponent/statisticalComponent'
import FromToPicker from '../BaseComponent/FromToPicker'
import cookie from 'react-cookies'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import SearchableCombo from '../BaseComponent/searchableCombo'

class StatisticalDrivers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      Statistical: [],
      printInfo: [],
      lengthProducts: 0,
      pageNumber: 1,
      aggregation: {},
      fromPayDate: '',
      toPayDate: '',
      fromDate: '',
      toDate: '',
      buttonClicked: false,
      Drivers: [],
      driverId: ''
    }
  }

  getAllStatistical = (
    pageSize = sessionStorage.getItem('dropDownVal'),
    pageNumber = sessionStorage.getItem('pageNumber'),
    params = sessionStorage.getItem('params')
  ) => {
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_PAYMENT_STATISTICAL
        }?export=false&pageSize=${pageSize}&pageNumber=${pageNumber}&${params}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable,.print').fadeIn()

          this.setState({
            Statistical: response.data.object.result,
            lengthProducts: response.data.object.countAll,
            aggregation: response.data.object.aggregation
          })
        } else {
          $('.showBaseTable,.print').fadeOut()

          // message.error(response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  componentDidMount() {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', ``)
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }
  onResultFetched(data) {
    this.setState({
      Statistical: data
    })
  }

  changeDropDown(data) {
    this.setState({
      Statistical: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  handleChangeFromPayDate = (fromPayDate) => {
    this.setState({
      fromPayDate
    })
  }

  handleChangeToPayDate = (toPayDate) => {
    this.setState({
      toPayDate
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  filter() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let paymentDateMin = this.state.fromPayDate
    let paymentDateMax = this.state.toPayDate
    let invoiceNum = this.convertDigit(document.getElementById('invoiceNum').value.trim())
    let invoiceId = this.convertDigit(document.getElementById('invoiceId').value.trim())
    let paid = document.getElementById('paid').value
    let accountTypeId = document.getElementById('accountTypeId').value
    let confirmed = document.getElementById('confirmed').value
    let canceled = document.getElementById('canceled').value
    let payOnDelivery = document.getElementById('payOnDelivery').value
    let paymentAmountMin = this.convertDigit(document.getElementById('paymentAmountMin').value.trim())
    let paymentAmountMax = this.convertDigit(document.getElementById('paymentAmountMax').value.trim())
    let lastState = document.getElementById('lastState').value
    var deliveryPackId = $('#deliveryPackId').val()
    var {personId} = this.props.match.params
    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId

    if (
      accountTypeId === '' &&
      invoiceId === '' &&
      driverId === '' &&
      canceled === '' &&
      confirmed === '' &&
      paymentDateMin === '' &&
      paymentDateMax === '' &&
      paymentAmountMin === '' &&
      paymentAmountMax === '' &&
      lastState === '' &&
      minDate === '' &&
      maxDate === '' &&
      invoiceNum === '' &&
      paid === '' &&
      payOnDelivery === '' &&
      deliveryPackId === ''
    ) {
      message.error('حداقل یک فیلتر وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ تحویل ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ تحویل انتها صحیح نیست')
    } else if ((paymentDateMin != '' || paymentDateMin == null) && isNaN(paymentDateMin)) {
      message.error('فرمت تاریخ پرداخت ابتدا صحیح نیست')
    } else if ((paymentDateMax != '' || paymentDateMax == null) && isNaN(paymentDateMax)) {
      message.error('فرمت تاریخ پرداخت انتها صحیح نیست')
    } else {
      sessionStorage.setItem(
        'params',
        `accountTypeId=${accountTypeId}&invoiceId=${invoiceId}&driverId=${driverId}&deliveryPackId=${deliveryPackId}&payOnDelivery=${payOnDelivery}&paid=${paid}&invoiceNum=${invoiceNum}&planDateMax=${maxDate}&planDateMin=${minDate}&lastState=${lastState}&paymentAmountMax=${paymentAmountMax}&paymentAmountMin=${paymentAmountMin}&paymentDateMax=${paymentDateMax}&paymentDateMin=${paymentDateMin}&confirmed=${confirmed}&canceled=${canceled}&deliveryPackId=${deliveryPackId}&driverId=${personId}`
      )
    }
    this.getAllStatistical()
  }

  exportExcel = () => {
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_PAYMENT_STATISTICAL
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['planDate'] = jMoment(excelReport[i]['planDate']).format('jYY/jMM/jDD')
            excelReport[i]['bazeTahvil'] =
              excelReport[i]['planTimeFrom'].substr(0, 5) + ' - ' + excelReport[i]['planTimeTo'].substr(0, 5)

            if (excelReport[i].driver === null) {
              excelReport[i].driver = ''
            } else {
              excelReport[i].driver = excelReport[i].driver['name']
            }

            if (excelReport[i].driver === null) {
              excelReport[i].mobile = ''
            } else {
              excelReport[i].mobile = excelReport[i].driver['mobile']
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  getPrintInfo = () => {
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_PAYMENT_STATISTICAL}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result,
            aggregation: response.data.object.aggregation
          })

          setTimeout(() => {
            window.print()
          }, 2000)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 landscape;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  render() {
    let excelColumns = [
      {title: 'نام شهر', value: 'cityName'},
      {title: 'عرض جغرافیایی', value: 'latitude'},
      {title: 'نام استان', value: 'provinceName'},
      {title: 'طول جغرافیایی', value: 'longitude'}
    ]

    var params = sessionStorage.getItem('params')
    let reporterName = cookie.load('name')
    let printCol = ['ردیف', 'نام', 'موبایل', 'شناسه پارت تحویل', 'مبلغ', 'بازه زمانی', 'نحوه پرداخت', 'اسم بانک']

    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="سرجمع پرداختی رساننده ها"
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={8}
              rightColSpan={4}
              centerColSpan={1}
              leftColSpan={4}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.driver == null ? '-' : item.driver.name}</td>
                  <td>{item.driver == null ? '-' : item.driver.mobile}</td>
                  <td>{item.planId}</td>
                  <td className="priceCell">{accounting.formatMoney(item.paymentAmount, '', ',')}</td>
                  <td>
                    {jMoment(item.planDate).format('jYYYY/jMM/jDD') +
                      ' - ' +
                      item.planTimeFrom +
                      ' تا ' +
                      item.planTimeTo}
                  </td>
                  <td>{item.account.name}</td>
                  <td>{item.account.bank}</td>
                </tr>
              ))}
              <tr>
                <td colSpan={4} />
                <td className="priceCell">{accounting.formatMoney(this.state.aggregation.amount, '', ',')}</td>
                <td colSpan={4} />
              </tr>
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش سرجمع پرداختی رساننده.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'driver'}
                field={'driver'}
                title={'رساننده'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'mobile'}
                field={'mobile'}
                title={'موبایل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'planId'}
                field={'planId'}
                title={'شناسه پارت تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'planDate'}
                field={'planDate'}
                title={'تاریخ تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'bazeTahvil'}
                field={'bazeTahvil'}
                title={'بازه تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>توزیع</li>
            <li>سرجمع پرداختی رساننده</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  url={REPORT_DISPATCH.REPORT_DISPATCH_PAYMENT_STATISTICAL}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  printComponent={this.printTable}
                  execelUrl="report/dispatch/payment/statistical?export=true"
                  excelColumns={excelColumns}
                  titleAdd="افزودن شهر"
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ تحویل از"
                  toLabel="تاریخ تحویل تا"
                  defaulValue={true}
                  fromId="from"
                  toId="to"
                />

                <FromToPicker
                  onChangeFromDate={this.handleChangeFromPayDate}
                  onChangeToDate={this.handleChangeToPayDate}
                  fromLabel="تاریخ پرداخت از"
                  toLabel="تاریخ پرداخت تا"
                  defaulValue={false}
                  fromId="fromPay"
                  toId="toPay"
                />

                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.Drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>

                <div className="formComponent">
                  <label>شناسه پارت تحویل</label>
                  <input className="form-control" id="deliveryPackId" type="text" />
                </div>

                <div className="formComponent">
                  <label>شماره فاکتور:</label>
                  <input type="text" className="form-control" id="invoiceNum" name="invoiceNum" />
                </div>

                <div className="formComponent">
                  <label>شناسه فاکتور:</label>
                  <input type="text" className="form-control" id="invoiceId" name="invoiceId" />
                </div>

                <div className="formComponent">
                  <label>وضعیت تایید :</label>
                  <select className="form-control" id="confirmed" name="confirmed">
                    <option value="">-------</option>
                    <option selected={true} value={1}>
                      تایید شده
                    </option>
                    <option value={0}>تایید نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>وضعیت کنسل :</label>
                  <select className="form-control" id="canceled" name="canceled">
                    <option value="">-------</option>
                    <option value={1}>کنسل شده</option>
                    <option selected={true} value={0}>
                      کنسل نشده
                    </option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>وضعیت پرداخت :</label>
                  <select className="form-control" id="paid" name="paid">
                    <option value="">-------</option>
                    <option value={1}>پرداخت شده</option>
                    <option value={0}>پرداخت نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>پرداخت در محل :</label>
                  <select className="form-control" id="payOnDelivery" name="payOnDelivery">
                    <option value="">-------</option>
                    <option value={1}>بله</option>
                    <option value={0}>خیر</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>نوع پرداخت :</label>
                  <select className="form-control" id="accountTypeId" name="accountTypeId">
                    <option value="">-------</option>
                    <option value={'1'}>پرداخت از قبل</option>
                    <option value={'50'}>نقدی</option>
                    <option value={'100'}>کارتخوان</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>حالت:</label>
                  <select className="form-control" id="lastState" name="lastState">
                    <option value="">-------</option>
                    <option value="-100">کنسل</option>
                    <option value="-75">مرجوعی</option>
                    <option value="-50">بازگشتی</option>
                    <option value="100">تخصیص مجدد</option>
                    <option value="-1">تخصیص داده نشده</option>
                    <option value="1">فعال</option>
                    <option value="5">اول فعال</option>
                    <option value="10">شروع شده</option>
                    <option value="18">تسویه شده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label> پرداخت از :</label>
                  <input type="text" className="form-control" id="paymentAmountMin" name="paymentAmountMin" />
                </div>

                <div className="formComponent">
                  <label> پرداخت تا :</label>
                  <input type="text" className="form-control" id="paymentAmountMax" name="paymentAmountMax" />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <StatisticalComponent data={this.state.Statistical} aggregation={this.state.aggregation} />

            <div className="paginationWrapp showBaseTable print">
              <Page
                defaultCurrent={1}
                total={this.state.lengthProducts}
                onResultFetched={this.onResultFetched.bind(this)}
                url="report/dispatch/payment/statistical"
                urlParams={params}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default StatisticalDrivers
